import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { GlobalOutlined } from '@ant-design/icons';

const LanguageToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(239, 179, 72, 0.3);

  &:hover {
    background: rgba(239, 179, 72, 0.1);
    border-color: #efb348;
  }

  @media (max-width: 768px) {
    gap: 4px;
    padding: 6px 8px;
  }
`;

const LanguageIcon = styled(GlobalOutlined)`
  color: #efb348;
  font-size: 16px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const LanguageText = styled.span`
  color: white;
  font-size: 14px;
  font-weight: 500;
  min-width: 24px;
  text-align: center;

  @media (max-width: 768px) {
    min-width: 20px;
    font-size: 12px;
  }
`;

const LanguageToggle = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLanguage = i18n.language === 'en' ? 'zh' : 'en';
    i18n.changeLanguage(newLanguage);
  };

  const getCurrentLanguageDisplay = () => {
    return i18n.language === 'en' ? 'EN' : '中';
  };

  return (
    <LanguageToggleContainer onClick={toggleLanguage} title="Switch Language">
      <LanguageIcon />
      <LanguageText>{getCurrentLanguageDisplay()}</LanguageText>
    </LanguageToggleContainer>
  );
};

export default LanguageToggle;
